import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Card, Select, Typography } from '@p81-common/ui';
import type { CardProps, DropdownMenuItem } from '@p81-common/ui';
import { NETWORK_ROLLOUT_SELECTION_LIMIT } from '../helpers/config';
import createClasses from './styles';

interface ActionCardProps extends CardProps {
  isLoading?: boolean;
  listItems: DropdownMenuItem[];
  selectValue: string;
  handleSelectChange: (
    name: string | number,
    value?: string | number | readonly string[] | undefined
  ) => React.MouseEventHandler<HTMLLIElement>;
  handleUpdateNetworkClick: (event?: React.MouseEvent) => void;
  handleUpdateServicesClick: (event?: React.MouseEvent) => void;
}

const ActionCard = ({
  isLoading,
  listItems,
  selectValue,
  handleSelectChange,
  handleUpdateNetworkClick,
  handleUpdateServicesClick,
  ...otherProps
}: ActionCardProps) => {
  const classes = createClasses();
  const { t } = useTranslation(['activity']);

  return (
    <Card
      indicator={false}
      columns={[
        {
          field: 'dropDown',
          children: (
            <>
              <Typography variant="h4">
                {otherProps.disabled && !isLoading
                  ? t('activity:networkRollout.ACTION_CARD_DISABLED', {
                      selectionLimit: NETWORK_ROLLOUT_SELECTION_LIMIT
                    })
                  : t('activity:networkRollout.ACTION_CARD_ENABLED')}
              </Typography>
              {!true && (
                <Select
                  className={classes.dropDown}
                  value={selectValue}
                  menuContentProps={{
                    listItems: listItems,
                    handleClick: handleSelectChange
                  }}
                  error={false}
                  label={''}
                  placeholder={t(
                    'activity:networkRollout.ACTION_CARD_SELECT_PLACEHOLDER'
                  )}
                  disabled={true}
                />
              )}
            </>
          ),
          align: 'start',
          flex: 'auto',
          minWidth: 180
        },
        {
          field: 'updateNetworkButton',
          children: (
            <Button
              className={classes.cancelBtn}
              size="medium"
              color="third"
              onClick={handleUpdateNetworkClick}
            >
              {t('activity:networkRollout.UPGRADE_NETWORK_BUTTON')}
            </Button>
          ),
          align: 'end',
          hideDivider: true,
          marginLeft: 'auto',
          minWidth: 44
        },
        {
          field: 'updateServicesButton',
          children: (
            <Button
              className={classes.cancelBtn}
              size="medium"
              onClick={handleUpdateServicesClick}
            >
              {t('activity:networkRollout.UPDATE_SERVICES_BUTTON')}
            </Button>
          ),
          align: 'end',
          hideDivider: true,
          minWidth: 44
        }
      ]}
      {...otherProps}
    />
  );
};

export default ActionCard;
